export default "__VITE_ASSET__Bi45ivAp__"